/**
 * Validates Geofence and Georecency circles: Circles with validation errors should not be saved.
 *
 * @param circles - Array of geofence or georecency circles
 * @returns Error message if invalid circles detected, undefined otherwise
 */
export function validateCircles(circles) {
    if (!circles?.length) {
        return undefined;
    }
    const hasInvalidCircles = circles.some((circle) => circle.validations && circle.validations.length > 0);
    if (hasInvalidCircles) {
        return "One or more invalid locations were detected.";
    }
    return undefined;
}
//# sourceMappingURL=geofence.js.map